<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import PlusOrange from "#/assets/iconsDynamic/PlusOrange.vue";
import { useCardStore } from "#/store/card";
import { useMainStore } from "#/store/main";
import { useThemeStore } from "#/store/theme";
import ButtonDefault from "#/ui/buttons/default/ButtonDefault.vue";
import { formatPrice, getLocaleName } from "#/utils/i18next";
import PricePrerender from "#/utils/pricePrerender";

const { t, i18next } = useTranslation();

const storeMain = useMainStore();
const storeCard = useCardStore();
const themeStore = useThemeStore();

const { stateCard } = storeToRefs(storeCard);

const price = computed(
	() =>
		stateCard.value.currentModifier?.sizes?.find((size) => size.id === stateCard.value.selectedSize.id)?.price ??
		PricePrerender(stateCard.value.currentModifier),
);

const modifierSelectModal = () => {
	if (stateCard.value.currentModifier) stateCard.value.currentModifier.amount = stateCard.value.modalCount;
	storeCard.modifierSelect(stateCard.value.currentModifier!);

	stateCard.value.isModifiedAmount = false;
};

const clearCount = () => {
	stateCard.value.modalCount = 1;
	stateCard.value.currentModifier!.amount = 1;
};
</script>

<template>
	<div class="modified_amount">
		<div class="hide_image_corners">
			<img class="modifier_image" :src="stateCard.currentModifier?.image_link || themeStore.data?.fallback_image || ''" alt="">
			<div class="wrapper_modifier_title">
				<p class="amount_title">{{ getLocaleName(stateCard.currentModifier, i18next.language) }}</p>
				<p class="modifier_price">+<span>{{ formatPrice(price, storeMain.config_lib?.currency_symbol) }}</span></p>
			</div>
		</div>
	</div>
	<div class="wrapper_amount_counter">
		<div class="amount_mines" @click.stop="storeCard.minusAmount">
			<div></div>
		</div>
		<p class="amount_count">{{ stateCard.modalCount }}</p>
		<div class="amount_wrapper">
			<PlusOrange @click.stop="storeCard.plusAmount" />
		</div>
	</div>
	<p class="clear_count" @click.stop="clearCount">{{ t(`modal-amount.button.clear-count`) }}</p>
	<div class="add_counter_amount">
		<ButtonDefault :textButtonDefault="t(`modal-amount.button.add`)" :onClick="modifierSelectModal" class="button_add_group_modifiers" />
	</div>
</template>

<style scoped lang="scss">
  @use './modalAmount.scss'
</style>
